import "./_style.scss";
import { useContext, useEffect, useRef, useState } from "react";
import { GlobalContext } from "../../context/globalContext";
import { useLocation, useNavigate } from "react-router-dom";
import TkDataTable from "../../components/molecules/TkDataTable";
import TkBackButton from "../../components/molecules/TkBackButton";
import TkSearchForm from "../../components/molecules/TkSearchForm";
import { Box } from "@mui/material";
import { funFacilityInfoBodyList } from "./hooks/useHooks";
import {
  infoMessage,
  facilityInfoHeadTitleList,
  listData,
  schema,
} from "../SCRC050030/parts";
import { httpAPI_PRE012 } from "./api/request";
import { TkRouteContext } from "../../context/tkRouteContext";
import _ from "lodash";

/**
 * SCRC050030 施設の登録内容の確認
 * @return SCRC050030 施設の登録内容の確認
 */

const SCRC050030 = () => {
  const navigate = useNavigate();
  const [bodyList, setBodyList] = useState<any>([]);
  const location = useLocation();
  const selectId = location.state?.check;
  const { state, setState } = useContext(GlobalContext);

  const { state: routerState, setState: setRouterState } =
    useContext(TkRouteContext);
  const wantToSetInRouterList = useRef<any>(
    location.state?.wantToSetInRouterList ?? []
  );

  useEffect(() => {
    if (wantToSetInRouterList.current.length === 0) return;
    if (_.isEqual(wantToSetInRouterList.current, routerState.routerList))
      return;
    setRouterState({
      routerList: wantToSetInRouterList.current as any,
    });
  }, [wantToSetInRouterList, routerState.routerList, setRouterState]);

  // 初期表示API
  const handleInit = async () => {
    try {
      const res = await httpAPI_PRE012({
        contractorNo: state.authInfo?.contractorNo,
      });

      if (res.resultCd === "I0000") {
        const facilityInfoBodyList = funFacilityInfoBodyList(res);
        setBodyList(facilityInfoBodyList);

        setState({
          ...state,
          errorMsgId: "",
        });
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  // 検索ボタン押下時
  const handleSearch = async (value: any) => {
    try {
      const res = await httpAPI_PRE012({
        contractorNo: state.authInfo?.contractorNo,
        facilityKind: value.type,
        facilityName: value.name,
      });

      if (res.resultCd === "I0000") {
        const facilityInfoBodyList = funFacilityInfoBodyList(res);
        setBodyList(facilityInfoBodyList);

        setState({
          ...state,
          errorMsgId: "",
        });
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  useEffect(() => {
    handleInit();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Box className="SCRC050030" data-testid="SCRC050030PageForTest">
      {selectId && infoMessage[selectId]}

      <TkSearchForm
        listData={listData}
        onSearch={handleSearch}
        ruleSchema={schema}
      />

      <TkDataTable
        headList={facilityInfoHeadTitleList}
        bodyList={bodyList}
        pagin={true}
      />

      <Box className="TkBackButton">
        <TkBackButton />
      </Box>
    </Box>
  );
};

export default SCRC050030;
